import CategoriesPageContent from '../components/Categories/Categories.js';

const CategoriesPage = () => {
  return <CategoriesPageContent />;
};

export default CategoriesPage;
